<template>
    <b-breadcrumb
        :items="breadcrumbs"
        class="user-panel-breadcrumb font-weight-bold"></b-breadcrumb>
</template>

<script>
    export default {
        name: 'Breadcrumbs',
        props: {
            hideLevel: {
                type: Number,
                default: 0
            }
        },
        computed: {
            breadcrumbs() {
                return this.breadcrumbsDecorator(this.breadcrumbsConstructor())
            }
        },
        methods: {
            breadcrumbsConstructor() {
                let pathTransform = (to) => {
                    let arr = []
                    to.split('/').forEach(item => {
                        if (/[:]/.test(item)) {
                            arr.push(this.$route.params[item.slice(1)])
                            return
                        }
                        arr.push(item)
                    })
                    return arr.join('/')
                }
                let { $route } = this
                let breadcrumbs = []
                $route.matched.forEach((route, index) => {
                    if (route.meta.breadcrumb !== undefined) {
                        this.getParentRoute(route, breadcrumbs)
                        breadcrumbs.push({
                            to: pathTransform(route.path),
                            text: this.dynamicText(route.meta.breadcrumb)
                        })
                    }
                })

                if (this.$route.name === 'ReplenishmentItem') {
                    let breadcrumbItem = {
                        to: `/user-panel/inventory/replenishment/${this.$route.params.parent}/`
                    }
                    if (this.$route.params.parent === 'plans') {
                        breadcrumbItem.text = 'Replenishment plans'
                    }
                    if (this.$route.params.parent === 'shipments') {
                        breadcrumbItem.text = 'Replenishment Shipments'
                    }
                    if (this.$route.params.parent === 'troubles') {
                        breadcrumbItem.text = 'Replenishment troubles'
                    }
                    breadcrumbs.splice(-1, 0, breadcrumbItem)
                }

                if (this.$route.name === 'ReplenishmentAddProducts') {
                    let list = []
                    list[0] = {to: `/user-panel/inventory/replenishment/${this.$route.params.parent}/`}
                    list[1] = {
                        to: `/user-panel/inventory/replenishment/${this.$route.params.parent}/${this.$route.params.planId}${this.$route.query.planNumber ? '?planNumber=' + this.$route.query.planNumber : ''}`}

                    if (this.$route.params.parent === 'plans') {
                        list[0].text = 'Replenishment plans'
                        list[1].text = `View plans ${this.$route.query.planNumber ? this.$route.query.planNumber : this.$route.params.planId}` 
                    }
                    if (this.$route.params.parent === 'shipments') {
                        list[0].text = 'Replenishment Shipments'
                        list[1].text = `View shipping ${this.$route.params.planId}`
                    }
                    if (this.$route.params.parent === 'troubles') {
                        list[0].text = 'Replenishment troubles'
                        list[1].text = `View troubles ${this.$route.params.planId}`
                    }
                    breadcrumbs.splice(-1, 0, ...list)
                }

                return breadcrumbs
            },
            dynamicText(breadcrumb) {
                return breadcrumb.text ? breadcrumb.text : breadcrumb.getText(this.$route)
            },
            breadcrumbsDecorator(breadcrumbs) {
                if (this.hideLevel > 0) {
                    breadcrumbs.splice(0, this.hideLevel)
                    return breadcrumbs
                }
            },
            getParentRoute(route, breadcrumbs) {
                if (route !== undefined && route.meta.breadcrumb !== undefined && route.meta.breadcrumb.parent) {
                    if (this.$route.params.parentBred) {
                        let parent = this.$route.params.parentBred
                        let breadcrumbItem = {}
                        breadcrumbItem.to = parent.route.fullPath

                        if (parent.route.meta.breadcrumb !== undefined && parent.route.meta.breadcrumb.text !== undefined) {
                            breadcrumbItem.text = parent.route.meta.breadcrumb.text
                        } else {
                            breadcrumbItem.text = parent.name
                        }
                        breadcrumbs.push(breadcrumbItem)
                    }
                }
                return breadcrumbs
            }
        }
    }
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/UserPanel/Elements/Breadcrumbs/Breadcrumbs.vue